<template>
  <div class="article-box">
    <h5>APP下载</h5>
    <hr>
    <div class="article_content" v-html="data">
      <!--<div class="qrcode-box">
        <div id="qrcode" class="qrcode"></div>
        <p class="scanCode">扫一扫下载（安卓苹果通用）</p>
      </div>

      <el-row>
        <el-col :span="12">
          <h2 class="title">苹果系统安装步骤</h2>
          <p class="content">
            <img src="../assets/img/9002ef42ba0465c0c8fea3b669e41dff.png" title="1.png" alt="1.png">
            <span>扫描二维码，进入下载页面，点击下载安装</span>
          </p>
          <p class="content">
            <img src="../assets/img/f867536ad95ea56f226a2453fff34e7b.png" title="2.png" alt="2.png">
            <span>选择“允许”，保存描述文件</span>
          </p>
          <p class="content">
            <img src="../assets/img/eb9dc534a89834b15d2a874732726b18.png" title="3.png" alt="3.png">
            <span>在安装描述文件页面，点击右上角“安装”</span>
          </p>
          <p class="content">
            <img src="../assets/img/f2db0217bbd09602001f486dcd42059f.png" title="4.png" alt="4.png">
            <span>输入手机锁屏密码（若有设置）</span>
          </p>
          <p class="content">
            <img src="../assets/img/422b138d386f36e415c0ea09b7355526.png" title="5.png" alt="5.png">
            <span>点击“安装”按钮</span>
          </p>
          <p class="content">
            <img src="../assets/img/664369d4e0a0ab3835f12e014083f6b4.png" title="6.png" alt="6.png">
            <span>选择已安装描述文件“完成”</span>
          </p>
          <p class="content">
            <img src="../assets/img/610b89901c48baad866c6aab67f67df4.png" title="6.png" alt="6.png">
            <span>点击“下载完成，回到桌面查看</span>
          </p>
        </el-col>
        <el-col :span="10" :offset="2">
          <h1 class="title">安卓系统安装步骤</h1>
          <p class="content">
            <img src="../assets/img/9002ef42ba0465c0c8fea3b669e41dff.png" title="1.png" alt="1.png">
            <span>点击右上角选择浏览器</span>
          </p>
          <p class="content">
            <img src="../assets/img/f867536ad95ea56f226a2453fff34e7b.png" title="2.png" alt="2.png">
            <span>点击选择浏览器打开</span>
          </p>
          <p class="content">
            <img src="../assets/img/eb9dc534a89834b15d2a874732726b18.png" title="3.png" alt="3.png">
            <span>点击“下载安装</span>
          </p>
          <p class="content">
            <img src="../assets/img/f2db0217bbd09602001f486dcd42059f.png" title="4.png" alt="4.png">
            <span>点击“确定”按钮"</span>
          </p>
          <p class="content">
            <img src="../assets/img/422b138d386f36e415c0ea09b7355526.png" title="5.png" alt="5.png">
            <span>点击“打开”</span>
          </p>
          <p class="content">
            <img src="../assets/img/664369d4e0a0ab3835f12e014083f6b4.png" title="6.png" alt="6.png">
            <span>点击“安装”</span>
          </p>
          <p class="content">
            <img src="../assets/img/610b89901c48baad866c6aab67f67df4.png" title="6.png" alt="6.png">
            <span>点击“打开”按钮即可；</span>
          </p>
        </el-col>
      </el-row>-->
    </div>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  export default {
    name: "helpapp",
    data(){
      return{
        data:''
      }
    },
    methods:{
      getData(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'protocol',
              'type': 16,
            }
          })  .then(res => {
          let resData = res.data;
          if (res.data.code == 1) {
            that.data = resData.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
      }
    },
    mounted() {
      this.getData();
    }
  }
</script>

<style scoped>
  @import url("./../assets/css/style.css");

  * {
    line-height: 1.5;
    text-align: left;
    margin-top: 0;
    font-weight: 400;
  }

  h5 {
    font-size: 20px;
    font-weight: 500;
  }
  .qrcode-box{
    width: 100%;
  }
  .qrcode{
    text-align: center;
    margin: 0 auto;
  }
  .qrcode img{
    text-align: center;
    margin: 0 auto;
    display: block;
  }
  img{
    margin: 0 auto;
  }
  .title{
    color: rgb(255,0,0);
    margin-bottom: 16px;
    font-size: 25px;
  }
  .content{
    font-size: 20px;
    margin-bottom: 16px;
  }
  .scanCode{
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpapp.vue